import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioSupportForm from "../common/support_form.js";
import IllumioSupportUtils from "../common/support_utils.js";
import IllumioDomUtils from "../common/dom_utils.js";

export class ContactModel extends IllumioEventEmitter {
    constructor() {
        super();

        let csrf = IllumioSupportForm.getCsrf();
        this.authenticity_token = (csrf) ? csrf['authenticity_token'] : null,

        this.data = null;
        this.opData = null; // Result of create/edit operations
    }

    loadContact(apiPath) {
        console.debug(`ContactModel.loadContact(): apiPath: ${apiPath}`);
        this.opData = null;
        $.ajax({
            method: 'get',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: apiPath,
            beforeSend: this.commonAjaxBeforeSendHandler.bind(this),
            error: this.loadContactAjaxErrorHandler.bind(this),
            success: this.loadContactAjaxSuccessHandler.bind(this),
        });
    }

    saveContact(theForm) {
        console.debug('ContactModel.saveContact() ');
        this.generatePayload(theForm);
        let url = theForm.action;
        let method = 'put';
        if (url.match(/\/new$/)) {
            let replacement = (this.data && this.data.id && this.data.id.length>0) ? '/'+this.data.id : '';
            url = url.replace(/\/new$/, replacement);
            method = (replacement.length>0) ? 'put' : 'post';
        }
        this.opData = null;
        $.ajax({
            method: method,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(this.payload),
            url: url,
            beforeSend: this.commonAjaxBeforeSendHandler.bind(this),
            error: this.commonContactAjaxErrorHandler.bind(this),
            success: this.commonContactAjaxSuccessHandler.bind(this),
        });
    }

    deleteContact(theForm) {
        console.debug(`ContactModel.deleteContact()`);
        $.ajax({
            method: 'delete',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({ authenticity_token: this.authenticity_token }),
            url: theForm.action,
            beforeSend: this.commonAjaxBeforeSendHandler.bind(this),
            error: this.commonContactAjaxErrorHandler.bind(this),
            success: this.commonContactAjaxSuccessHandler.bind(this),
        });
        
    }

    getPortalUserType(name) {
        console.debug(`getPortalUserType(): name: ${name}`);
        console.debug(this);
        if (this.data && this.data.metadata && this.data.metadata.portal_user_type) {
            for (let i=0;i<this.data.metadata.portal_user_type.length;i++) {
                if (this.data.metadata.portal_user_type[i].label===name || this.data.metadata.portal_user_type[i].value===name) {
                    return this.data.metadata.portal_user_type[i];
                }
            }
        }
        return null;
    }

    /**
     * ES6: Private method
     */
    generatePayload(theForm) {
        console.debug('ContactModel.generatePayload()');
        const payload = {
            authenticity_token: this.authenticity_token,
            first_name: theForm['first_name'].value,
            last_name: theForm['last_name'].value,
            title: theForm['title'].value,
            phone: theForm['phone'].value,
            mobile: theForm['mobile'].value,
        };
        if (this.data && this.data.id) {
            payload['id'] = this.data.id;
        }
        if (theForm['email'] && theForm['email'].tagName==='INPUT' && theForm['email'].type==='email') {
            payload['email'] = theForm['email'].value;
        }
        if (this.data && this.data.metadata && this.data.metadata.full_profile) {
            payload['street'] = theForm['street'].value;
            payload['city'] = theForm['city'].value;
            payload['zip'] = theForm['zip'].value;
            if (theForm['country_code'].selectedIndex>0) {
                payload['country_code'] = theForm['country_code'].options[theForm['country_code'].selectedIndex].value;
            }
            if (theForm['state_code'].disabled===false && theForm['state_code'].selectedIndex>0) {
                payload['state_code'] = theForm['state_code'].options[theForm['state_code'].selectedIndex].value;
            }
            if (theForm['timezone'] && theForm['timezone'].selectedIndex>0) {
                payload['timezone'] = theForm['timezone'].options[theForm['timezone'].selectedIndex].value;
            }
            payload['portal_user_type'] = theForm['portal_user_type'].options[theForm['portal_user_type'].selectedIndex].value;

        }
        this.payload = payload;
        return payload;
    }

    /**
     * ES6: Private method
     */
    commonAjaxBeforeSendHandler(jqXHR, settings) {
        console.debug(jqXHR);
        console.debug(settings);
        // console.debug(this.data);
    }
    
    /**
     * ES6: Private method
     */
    commonAjaxErrorHandler(jqXHR, textStatus, errorThrown) {
        // console.debug(jqXHR);
        console.debug(textStatus);
        console.debug(errorThrown);
    }
    
    /**
     * ES6: Private method
     */
    loadContactAjaxErrorHandler(jqXHR, textStatus, errorThrown) {
        this.commonAjaxErrorHandler(jqXHR, textStatus, errorThrown);
        // TODO: this.data = jqXHR.responseJSON;
        this.emit('renderResult', {});
    }
    
    /**
     * ES6: Private method
     */
    loadContactAjaxSuccessHandler(data, textStatus, jqXHR) {
        console.debug('ContactModel.loadContactAjaxSuccessHandler(): ');
        console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);

        this.data = data;
        this.emit('renderResult', {});
    }

    /**
     * ES6: Private method
     */
    commonContactAjaxSuccessHandler(data, textStatus, jqXHR) {
        console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);

        this.opData = data;
        this.data = data;
        this.emit('renderResult', {});
    }

    /**
     * ES6: Private method
     */
    commonContactAjaxErrorHandler(jqXHR, textStatus, errorThrown) {
        this.commonAjaxErrorHandler(jqXHR, textStatus, errorThrown);
        this.opData = jqXHR.responseJSON;
        this.emit('renderResult', {});
    }
    
    /**
     * Lookup the timezone in the metadata. Returns the timezone value when matching the web_code.
     * ES6: Arrow function + handler with .bind(this)
     */
    getTimezoneDisplayValue() {
        let timezoneDisplayValue = null;
        if (this.data && this.data.profile && this.data.profile.timezone && this.data.metadata && this.data.metadata.timezone) {
            const _timezonesForEachHandler = function(timezone) {
                if (this.data.profile.timezone===timezone.web_code) {
                    timezoneDisplayValue = timezone.value;
                }
            }
            this.data.metadata.timezone.forEach(_timezonesForEachHandler.bind(this));
        }
        return timezoneDisplayValue;
    }

    /**
     * Lookup states array in metadata. Return the states array when matching the country.value.
     * ES6: Arrow function + handler with .bind(this)
     */
    getStates(countryValue) {
        let states = null;
        let _countryStateForEachHandler = null;
        if (countryValue) {
            _countryStateForEachHandler = function(country) {
                if (countryValue && country.value===countryValue) {
                    states = country.states;
                }
            }
        } else {
            _countryStateForEachHandler = function(country) {
                if (country.value===this.data.profile.country_code) {
                    states = country.states;
                }
            }
        }
        this.data.metadata.country_state.forEach(_countryStateForEachHandler.bind(this));
        return states;
    }
}

export class ContactView extends IllumioEventEmitter {
    constructor(model) {
        super();
        this.model = model;

        // formMode Options: show, new, edit
        this.formMode = 'show';
        this.isFirstTime = true;
        if (document.URL.match('/account/contact/')) {
            this.formUsage = 'contact';
        } else if (document.URL.match('/account/profile/')) {
            this.formUsage = 'profile';
        } else {
            this.formUsage = 'unknown';
        }

        this.fullProfileDivs = document.getElementsByClassName('ilo-full-profile');
        this.contactDivs = document.getElementsByClassName('ilo-contact');
        this.actionButtons = document.getElementsByClassName('actionButtons');

        this.theForm = document.getElementById('theForm');
        this.theMessage = document.getElementById('theMessage');
        this.currentEventTarget = null;
        // this.model.formName = this.theForm.name;

        this.actionButtonDiv = document.getElementById('actionButtonDiv');

        this.initializeWidgetsEvent();
        this.initializeRequiredLabel();

        this.model.on('renderResult', this.renderResult.bind(this));
        
        // Commented out for SP-1234
        // this.updateRequiredField();
        
        if (document.URL.match(/\/new(\.html)?/)) {
            // Display the blank form.
            this.formMode = 'new';
            this.model.loadContact(this.theForm.action.replace(/new$/, 'metadata'));
            // this.displayDataFormRow();
            this.toggleContactDisplay();
        } else {
            const regexResult = document.URL.match(/\/([A-Za-z0-9]+)\.html$/)
            if (regexResult && regexResult.length>0 && regexResult[regexResult.length-1].length>=15) {
                const sfdcContactId = regexResult[regexResult.length-1];
                this.model.loadContact(this.theForm.action);
            }
            // this.toggleButtonDisability(); // This toggle button disabled to true (i.e, disabled the button)
        }            
    }

    /**
     * ES6: Private method, handler with .bind(this)
     */
    initializeWidgetsEvent() {
        if (this.actionButtonDiv) {
            for (let i=0;i<this.actionButtonDiv.children.length;i++) {
                const element = this.actionButtonDiv.children[i];
                element.style.display = 'none';
                if (element.id==='addButtonNew') {
                    element.onclick = this.addActionButtonOnClickHandler.bind(this);
                } else if (element.id==='editButtonShow') {
                    element.onclick = this.editActionButtonOnClickHandler.bind(this);
                } else if (element.id==='deleteButtonShow') {
                    element.onclick = this.deleteActionButtonOnClickHandler.bind(this);
                } else if (element.id==='submitButtonEdit') {
                    element.onclick = this.submitActionButtonOnClickHandler.bind(this);
                } else if (element.id==='cancelButtonEdit') {
                    element.onclick = this.cancelEditActionButtonOnClickHandler.bind(this);
                }
            }
            this.actionButtonDiv.classList.remove('hidden');
        }

        this.theForm['country_code'].onchange = this.countryCodeSelectOnChangeHandler.bind(this);
        this.theForm['portal_user_type'].onchange = this.portalUserTypeOnChangeHandler.bind(this);

    }

    /**
     * ES6: Private method
     */
    initializeRequiredLabel() {
        if (this.theForm) {
            for (let i=0;i<this.theForm.elements.length;i++) {
                const element = this.theForm.elements[i];
                if (element.dataset['required']==='true') {
                    if (element.parentElement.previousElementSibling && element.parentElement.previousElementSibling.tagName==='LABEL') {
                        const requiredElement = document.createElement('span');
                        requiredElement.classList.add('required');
                        requiredElement.classList.add('hidden');
                        requiredElement.textContent = '*';

                        const labelElement = element.parentElement.previousElementSibling;
                        labelElement.parentElement.insertBefore(requiredElement, labelElement.nextElementSibling);
                    }
                }
            }
        }
    }

    /**
     * ES6: Private method
     * Unused as of SP-1234.
     */
    updateRequiredField() {
        if (this.theForm && this.theForm.elements.length>0) {
            for (let i=0;i<this.theForm.elements.length;i++) {
                const element = this.theForm.elements[i];

                // console.debug(`»»»`);
                // console.debug(element);
                if (element.dataset['required']==='true' && element.parentElement && element.parentElement.parentElement && element.parentElement.parentElement.classList.contains('hidden')) {
                    // console.debug(`---> Set required to false`);
                    element.required = false;
                    element.dataset['required'] = 'false';
                }
            }
        }
    }

    /**
     * ES6: Private method
     */
    renderResult(args) {
        console.debug('PortalView.renderResult(args)');
        console.debug(args);
        console.debug(this);

        if (this.model.opData) {
            if (this.model.opData.status===false || this.model.opData.success===false) {
                this.renderFailureResponse();
            } else  { // this.model.opData.success===true
                if (this.model.opData.records_updated) { 
                    // Delete Contact
                    const backToAccountButtonShow = document.getElementById('backToAccountButtonShow');
                    if (backToAccountButtonShow) {
                        location.href = backToAccountButtonShow.href;
                    } else {
                        location.href = '../index.html';
                    }
                } else if (this.model.opData.id && this.theForm.action.match('\/new')) {
                    // New Contact
                    const sfdcContactId = this.model.opData.id;
                    location.href = `${sfdcContactId}.html`
                } else if (this.model.opData.id) {
                    // Edit Contact
                    console.debug(`» this.model.opData.id: ${this.model.opData.id}`);
                    this.renderSuccessResponse();
                }
            }
        } else if (this.model.data) {
            if (this.model.data.success===true) {
                this.renderSuccessResponse();
            } else if (this.model.data && this.model.data.success===false) {
                this.renderFailureResponse();
            }
        } else {
            console.debug(`#renderResult(): Missing success status!`);
        }

        if (this.currentEventTarget) {
            this.currentEventTarget.disabled = false;
        }
    }

    /**
     * ES6: Private method
     */
    renderFailureResponse() {
        if (this.theMessage && this.model.opData && this.model.opData.error && this.model.opData.error.message) {
            this.theMessage.textContent = this.model.opData.error.message;
        } else if (this.theMessage && this.model.data && this.model.data.error && this.model.data.error.message) {
            this.theMessage.textContent = this.model.data.error.message;
        } else {
            this.theMessage.textContent = 'We are unable to process your request due to unexpected technical difficulties. Please try again later.';
        }
        this.theMessage.style.display = 'block';
        this.actionButtonDiv.classList.remove('hidden');

        // const backToAccountButton = document.getElementById('backToAccountButton');
        // if (backToAccountButton) {
        //     backToAccountButton.style.display = 'inline';
        // }
    }

    /**
     * ES6: Private method
     */
    renderSuccessResponse() {
        this.theMessage.textContent = '';
        this.theMessage.style.display = 'none';

        if (this.model.data.metadata.form_mode && this.model.data.metadata.form_mode==='show') {
            this.formMode = 'show';
        }
        if (this.isFirstTime===true && this.startsWithEditMode()===true) {
            this.isFirstTime = false;
            this.formMode = 'edit';
        }
        this.toggleContactDisplay();

        if (this.model.data.metadata && this.model.data.metadata.profile_fields) {
            const _fieldsForEachHandler = function(name) {
                let profileFieldName = name;
                let value = (this.model.data.profile) ? this.model.data.profile[profileFieldName] : null;
                if (name==='country_code') {
                    profileFieldName = 'country';
                    value = (this.model.data.profile) ? this.model.data.profile['country'] : null;
                    this.populateStateCountryOptions();
                } else if (name==='state_code') {
                    value = (this.model.data.profile) ? this.model.data.profile['state'] : null;
                } else if (name==='timezone') {
                    value = this.model.getTimezoneDisplayValue();
                    this.populateTimezoneOptions();
                    if (value) {
                        const timezoneColumn = document.getElementById('timezoneColumn');
                        if (timezoneColumn) {
                            timezoneColumn.classList.remove('hidden');
                        }
                    }
                } else if (name==='portal_user_type') {
                    this.populatePortalUserTypeOptions();
                }

                this.populateDataToDom(name, value);
            }
            this.model.data.metadata.profile_fields.forEach(_fieldsForEachHandler.bind(this));
        }
        
        this.displayDataFormRow();
        const changePasswordButton = document.getElementById('changePasswordButton');
        if (changePasswordButton && this.model.data.metadata && 
                this.model.data.metadata.change_password_url!==undefined && 
                this.model.data.metadata.change_password_url) {
            changePasswordButton.href = this.model.data.metadata.change_password_url;
        }

        this.displayButtons();
    }

    /**
     * ES6: Private method
     */
    startsWithEditMode() {
        const qs = IllumioSupportUtils.getParameters(window.location.search)
        if (qs && qs.edit==='true') {
            return true;
        }
        return false;
    }

    /**
     * ES6: Private method
     */
    toggleButtonDisability() {
        if (this.actionButtonDiv) {
            for (let i=0;i<this.actionButtonDiv.childElementCount;i++) {
                if (this.actionButtonDiv.children[i].tagName==='BUTTON') {
                    this.actionButtonDiv.children[i].disabled = !this.actionButtonDiv.children[i].disabled;
                }
            }
        }
    }

    /**
     * ES6: Private method
     */
    toggleContactDisplay() {
        console.debug('#toggleContactDisplay()');
        for (let i=0;i<this.theForm.elements.length;i++) {
            const element = this.theForm.elements[i];
            if (element.tagName==='INPUT' || element.tagName==='SELECT') {
                switch (this.formMode) {
                    case 'show':
                        if (element.previousElementSibling) element.previousElementSibling.style.display = 'block';
                        element.style.display = 'none';
                        break;
                    case 'edit':
                        if (element.previousElementSibling) element.previousElementSibling.style.display = (element.name==='email') ? 'block' : 'none';
                        element.style.display = (element.name==='email') ? 'none' : 'inline';
                        break;
                    case 'new':
                        if (element.previousElementSibling) element.previousElementSibling.style.display = 'none';
                        element.style.display = 'inline';
                        break;
                }
                if (element.name==='email') {
                    element.type = (this.formMode==='new') ? 'email' : 'hidden';
                    element.required = (this.formMode==='new') ? 'required' : '';
                    if (element.parentElement.previousElementSibling) {
                        element.parentElement.previousElementSibling.style.display = (this.formMode==='new') ? 'inline' : 'none';
                    }
                }
                this.toggleRequiredFlagDisplay(element);
            }
        }
        if (this.formMode!=='show') {
            let stateCodeHasOptions = this.theForm['state_code'].options.length>1;
            this.theForm['state_code'].disabled = (stateCodeHasOptions) ? false : true;
        }
    }

    /**
     * ES6: Private method
     */
    toggleRequiredFlagDisplay(formElement, isDisplay=false) {
console.debug(`toggleRequiredFlagDisplay()`);
console.debug(formElement);
        if (formElement && 
                formElement.parentElement && 
                formElement.parentElement.parentElement && 
                formElement.parentElement.parentElement.children[0].tagName==='LABEL' && 
                formElement.parentElement.parentElement.children[0].nextElementSibling && 
                formElement.parentElement.parentElement.children[0].nextElementSibling.tagName==='SPAN') {
            const requiredFlagElement = formElement.parentElement.parentElement.children[0].nextElementSibling;
            if (formElement.style.display==='inline' || formElement.style.display==='block') {
                requiredFlagElement.classList.remove('hidden');
            } else {
                requiredFlagElement.classList.add('hidden');
            }
        }
    }

    /**
     * ES6: Private method
     */
    displayButtons() {
        if (this.actionButtonDiv && this.formMode) {
            for (let i=0;i<this.actionButtonDiv.children.length;i++) {
                const element = this.actionButtonDiv.children[i];

                if (element.dataset['action']===this.formMode && element.tagName==='A') { // && (element.tagName==='BUTTON' || (element.tagName==='A'/* && element.href!==document.URL*/))) {
                    element.style.display = 'inline-flex';
                } else if (element.dataset['action']===this.formMode) {
                    element.style.display = 'inline';
                } else {
                    element.style.display = 'none';
                }
                element.disabled = false;

                if (element.id==='changePasswordButtonShow' && this.formMode==='show') {
                    element.style.display = (this.formUsage==='profile') ? 'inline' : 'none';
                }
            }
            this.actionButtonDiv.classList.remove('hidden');
        }
    }

    /**
     * ES6: Private method
     */
    displayDataFormRow() {
        // Display contact rows
        for (let i=0;i<this.contactDivs.length;i++) {
            this.contactDivs[i].classList.remove('hidden');
        }
        if (this.model.data && this.model.data.metadata && this.model.data.metadata.full_profile) {
            // Display the full profile rows
            for (let i=0;i<this.fullProfileDivs.length;i++) {
                if (this.fullProfileDivs[i].id==='timezoneColumn' && this.formMode==='new') {
                    this.fullProfileDivs[i].innerHTML = '&nbsp;';
                }
                this.fullProfileDivs[i].classList.remove('hidden');
            }
        }
    }

    /**
     * ES6: Private method, arrow function, and handler with .bind(this)
     */
    populateStateCountryOptions() {
        console.debug('this.populateStateCountryOptions()');
        const selectedCountryCode = (this.model.data.profile) ? this.model.data.profile['country_code'] : null;
        const selectedStateCode = (this.model.data.profile) ? this.model.data.profile['state_code'] : null;
        const countryCodeElement = this.theForm['country_code'];
        const stateCodeElement = this.theForm['state_code'];
        if (countryCodeElement && this.model.data.metadata.country_state) {
            const _statesForEachHandler = function(item) {
                stateCodeElement[stateCodeElement.options.length] = new Option(item.label, item.value, selectedStateCode===item.value, selectedStateCode===item.value);
            }
            const _countryStateForEachHandler = function(item) {
                countryCodeElement[countryCodeElement.options.length] = new Option(item.label, item.value, selectedCountryCode===item.value, selectedCountryCode===item.value);
                if (item.states && countryCodeElement.selectedIndex>0 && countryCodeElement.value===item.value && stateCodeElement) {
                    item.states.forEach(_statesForEachHandler);
                }
            }
            this.model.data.metadata.country_state.forEach(_countryStateForEachHandler);
            
            countryCodeElement.style.marginBottom = 0;

            if (stateCodeElement) {
                stateCodeElement.style.marginBottom = 0;
            }
        }
    }

    /**
     * ES6: Private method, arrow function, and handler with .bind(this)
     */
    populateTimezoneOptions() {
        console.debug('this.populateTimezoneOptions()');
        const selectedTimezone = (this.model.data.profile) ? this.model.data.profile['timezone'] : null;
        const timezoneElement = this.theForm['timezone'];
        if (this.model.data.metadata.timezone) {
            const _timezonesForEachHandler = function(item) {
                if (timezoneElement) {
                    timezoneElement[timezoneElement.options.length] = new Option(item.value, item.web_code, selectedTimezone===item.web_code, selectedTimezone===item.web_code);
                }
            }
            this.model.data.metadata.timezone.forEach(_timezonesForEachHandler);
        }
    }

    /**
     * ES6: Private method, arrow function, and handler with .bind(this)
     */
    populatePortalUserTypeOptions() {
        console.debug('this.populatePortalUserTypeOptions()');
        const selectedPortalUserType = (this.model.data.profile) ? this.model.data.profile['portal_user_type'] : null;
        const portalUserTypeElement = this.theForm['portal_user_type'];
        if (this.model.data.metadata.portal_user_type && portalUserTypeElement.options.length<=1) {
            const _portalUserTypesForEachHandler = function(item) {
                portalUserTypeElement[portalUserTypeElement.options.length] = new Option(item.label, item.value, selectedPortalUserType===item.label, selectedPortalUserType===item.value);
            }
            this.model.data.metadata.portal_user_type.forEach(_portalUserTypesForEachHandler);
            // Trigger the text to display the option description
            portalUserTypeElement.dispatchEvent(new Event('change'));
        }
    }

    /**
     * ES6: Private method
     */
    populateDataToDom(name, value) {
        const element = this.theForm[name];
        if (element && element.tagName==='INPUT') {
            element.value = value;
        }

        if (element && element.parentElement && element.parentElement.childElementCount>0) {
            if (element.tagName==='INPUT' && element.name==='email' && value) {
                IllumioDomUtils.removeChildren(element.parentElement.children[0]);

                const anchorElement = document.createElement('a');
                anchorElement.href = 'mailto:' + value;
                anchorElement.textContent = (value) ? value : '&nbsp;';
                element.parentElement.children[0].appendChild(anchorElement);
            } else if (element.tagName==='SELECT' && element.name==='portal_user_type' && value) {
                for (let i=1;i<=element.options.length;i++) {
                    if (element.options[i].value===value) {
                        element.parentElement.children[0].textContent = element.options[i].label;
                        break;
                    }
                }
            } else if (value) {
                element.parentElement.children[0].textContent = value;
                const portalUserTypeData = this.model.getPortalUserType(value);
                if (portalUserTypeData) {
                    element.parentElement.children[2].textContent = portalUserTypeData.description;
                }
            } else {
                element.parentElement.children[0].innerHTML = '&nbsp;';
            }
        }
    }

    /**
     * ES6: Private method
     */
    validateForm() {
        console.debug('this.validateForm()');
        console.debug(this);

        let invalidCounter = 0;
        if (this.theForm && this.theForm.elements.length>0) {
            for (let i=0;i<this.theForm.elements.length;i++) {
                if (this.theForm[i].required) { 
                    let isValid = IllumioSupportForm.validate(this.theForm[i], true);
                    console.debug(`» [${i}] ${this.theForm[i].name}: ${this.theForm[i].value}: ${isValid}`);
                    if (this.theForm[i].name==='email' && isValid) {
                        const _parts = this.theForm[i].value.split('@');
                        const domain = _parts[_parts.length-1];
                        if (!(this.model.data
                                && this.model.data.metadata
                                && this.model.data.metadata.valid_email_domains
                                && this.model.data.metadata.valid_email_domains.indexOf(domain)>=0)) {
                            isValid = false;
                            console.warn(`ContactView.validateForm(): Email domain is not matching known corporate domain!`);
                        }
                    }
                    if (!isValid) {
                        invalidCounter++;
                        // if (this.theForm[i].tagName==='SELECT' && this.theForm[i].nextElementSibling) {
                        //     this.theForm[i].nextElementSibling.style.width = this.theForm[i].offsetWidth+'px';
                        // } else 
                        if (this.theForm[i].nextElementSibling) {
                            this.theForm[i].nextElementSibling.classList.add('error');
                            this.theForm[i].nextElementSibling.classList.remove('hidden');
                        }
                    } else {
                        if (this.theForm[i].nextElementSibling) {
                            this.theForm[i].nextElementSibling.classList.add('hidden');
                        }
                    }
                }
            }
        }
        return (invalidCounter>0) ? false : true;
    }

    /**
     * ES6: Private method
     */
    addActionButtonOnClickHandler(event) {
        this.theMessage.style.display = 'none';

        event.preventDefault();
        console.debug('this.addActionButtonHandler()');

        let isValid = this.validateForm();
        if (isValid) {
            this.currentEventTarget = event.target;
            event.target.disabled = true;
            this.model.saveContact(this.theForm);
        }
    }

    /**
     * ES6: Private method
     */
    editActionButtonOnClickHandler(event) {
        this.theMessage.style.display = 'none';

        console.debug('this.editActionButtonHandler()');
        console.debug(event);
        console.debug(this);
        
        this.formMode = 'edit'; // Options: show, new, edit

        this.toggleContactDisplay();
        this.displayButtons();
        
        event.preventDefault();
    }

    /**
     * ES6: Private method
     */
    deleteActionButtonOnClickHandler(event) {
        this.theMessage.style.display = 'none';
        
        console.debug(`this.deleteActionButtonOnClickHandler`);
        console.debug(event);
        console.debug(this);

        this.model.deleteContact(this.theForm);

        event.preventDefault();
    }

    /**
     * ES6: Private method
     */
    submitActionButtonOnClickHandler(event) {
        this.theMessage.style.display = 'none';

        console.debug('this.submitActionButtonOnClickHandler()');
        if (!this.submitBuddonEdit) { this.submitBuddonEdit = event.target; }
        // console.debug(event);
        // console.debug(this);

        let isValid = this.validateForm();
        console.debug(`» isValid: ${isValid}`);
        if (isValid) {
            this.model.saveContact(this.theForm);

            // this.formMode = 'show';
            // this.toggleContactDisplay();
        }

        event.preventDefault();
    }

    /**
     * ES6: Private method
     */
    cancelEditActionButtonOnClickHandler(event) {
        this.theMessage.style.display = 'none';

        console.debug('this.cancelEditActionButtonOnClickHandler()');
        console.debug(event);
        console.debug(this);

        this.formMode = 'show';
        this.toggleContactDisplay();
        this.displayButtons();

        event.preventDefault();
    }

    /**
     * ES6: Private method
     */
    countryCodeSelectOnChangeHandler(event) {
        console.debug('this.countryCodeSelectOnChangeHandler()');
        // console.debug(event);
        // console.debug(this);
        
        let states = this.model.getStates(event.target.value);
        let stateCodeElement = event.target.form['state_code'];
        let selectedStateCode = (this.model.data.profile) ? this.model.data.profile.state_code : null;
        if (states) {
            stateCodeElement.length = 1;
            const _statesForEachHandler = function(item) {
                stateCodeElement[stateCodeElement.options.length] = new Option(item.label, item.value, stateCodeElement.value===selectedStateCode, stateCodeElement.value===selectedStateCode);
            }
            states.forEach(_statesForEachHandler);
        }
        this.theForm['state_code'].disabled = (states) ? false : true;
    }

    /**
     * ES6: Private method
     */
    portalUserTypeOnChangeHandler(event) {
        console.debug(`this.portalUserTypeOnChangeHandler()`);
        console.debug(event.target);
        const selectElement = event.target;
        const selectedValue = selectElement.options[selectElement.selectedIndex].value;
        if (selectElement.selectedIndex===0) {
            selectElement.nextElementSibling.textContent = '';
        } else if (selectedValue && 
                    this.model.data && 
                    this.model.data.metadata && 
                    this.model.data.metadata.portal_user_type) {
            for (let i=0;i<this.model.data.metadata.portal_user_type.length;i++) {
                if (this.model.data.metadata.portal_user_type[i].value===selectedValue) {
                    selectElement.nextElementSibling.textContent = this.model.data.metadata.portal_user_type[i].description;
                }
            }
        }
    }
}

export class ContactController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;
    }
}

/**
 * ES6: Arrow function
 */
// document.addEventListener('DOMContentLoaded', function() {
//     const model = new ContactModel();
//     window.ContactApp = new ContactController(model, new ContactView(model));
// });
